module.exports = __webpack_public_path__ + "img/vr1.e1c2189a.jpg";